module.exports = __webpack_public_path__ + "static/media/apshah.a508d9db.png";